import {
  SET_OPERATOR,
  SET_VALUE,
} from './actions';

import { EQUALS } from './operators';

export const defaultState = (defaultOperator = EQUALS) => ({
  operator: defaultOperator,
  value: null,
});

export const setOperator = (state, { operator }) => ({
  ...state,
  operator,
});

export const setValue = (state, { value }) => ({
  ...state,
  value,
});

export default (state = defaultState(), action) => {
  const reducer = {
    [SET_OPERATOR]: setOperator,
    [SET_VALUE]: setValue,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};
